import { render, staticRenderFns } from "./MitStorageDetailsPage.vue?vue&type=template&id=5a61ed6c&scoped=true"
import script from "./MitStorageDetailsPage.vue?vue&type=script&lang=js"
export * from "./MitStorageDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./MitStorageDetailsPage.vue?vue&type=style&index=0&id=5a61ed6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a61ed6c",
  null
  
)

export default component.exports